<template>
    <div id="topMostElement" class="providerSection">
        <v-btn
            v-if="valid && screen_width <= 930"
            icon
            class="black--text"
            @click="valid = false"
        >
            <v-icon
                dark
                left
            >
                {{ mdiArrowLeft }}
            </v-icon>
        </v-btn>
        <h1>
            <v-icon
                v-if="screen_width > 520"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiFlaskEmpty }}
            </v-icon>
            Request Patient Diagnostic Procedure <span v-if="showConsultResult()">Result</span>
            <v-btn
                v-if="valid && screen_width > 931"
                style="position: absolute; right: 6.5%; background-color: #009688; color: white;"
                class="ma-2"
                dark
                @click="valid = false"
            >
                <v-icon
                    dark
                    left
                >
                    {{ mdiChevronLeft }}
                </v-icon>{{ !showConsultResult() ? 'GO BACK' : 'GO TO MAIN' }}
            </v-btn>
        </h1>
        <div class="docInfoBody">
            <CheckEligibility
                v-if="!valid"
                @patientEligible="isPatientEligible"
            />
            <FormProcedureRequest
                v-else-if="!consultStatus"
                :patient-credentials="patientCredentials"
                @reCheckMembEligibility="valid = false"
                @procedureStatus="procedureStatus"
            />
            <ProcedureResult
                v-if="showConsultResult()"
                :data="consultData"
            />
        </div>
    </div>
</template>

<script>
import ProcedureResult from './ProcedureResult.vue'
import FormProcedureRequest from './FormProcedure/index.vue'
import CheckEligibility from './CheckEligibility.vue'
import { mdiArrowLeft, mdiChevronLeft, mdiFlaskEmpty } from '@mdi/js'
export default {
    components: {
        CheckEligibility,
        FormProcedureRequest,
        ProcedureResult
    },
    data: ()=>({
        mdiArrowLeft, mdiChevronLeft, mdiFlaskEmpty,
        consultData: null,
        consultStatus: false,
        patientCredentials: null,
        goToOptions: {
            duration: 500,
            offset: 0,
            easing: 'easeInOutCubic'
        },
        screen_width: document.documentElement.clientWidth + 9,
        valid: false
    }),
    mounted(){
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        showConsultResult() {
            return this.valid && this.consultStatus && this.consultData
        },
        procedureStatus(data) {
            this.$vuetify.goTo('#topMostElement', this.goToOptions)
            this.consultStatus  = true
            this.consultData    = data
        },
        isPatientEligible(data) {
            this.$vuetify.goTo('#topMostElement', this.goToOptions)
            this.patientCredentials = data
            this.valid              = true
            this.consultStatus      = false
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style scoped>
h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.docInfoBody {
    margin-top: 5%;
}
.providerSection {
    padding: 10px 7.5% 0 7.5%;
}
@media (max-width: 380px) {
  .providerSection {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (max-width: 599px) {
  .providerSection {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (min-width: 599px) and (max-width: 1264px) {
  .providerSection {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (min-width: 1264px) {
  .providerSection {
    padding: 10px 7.5% 0 7.5%;
  }
}
</style>
